<template>
  <div>
    <A11y-Dropdown
      :dropdown-props="{
        ref:'translateLanguageDropdown'
      }"
      :button-props="{
        type:'button',
        class:'btn btn-xs btn-gb-light dropdown-toggle',
        role:'combobox',
        'aria-haspopup':'listbox',
        id:'translate-dropdown-button-'+htmlId,
        'aria-controls':'translate-dropdown-menu-'+htmlId,
        'aria-label':'language of resources'
      }"
      :dom-attributes="{
        role:'listbox',
        id:'translate-dropdown-menu-'+htmlId
      }"
      @openedDropdown="openedDropdown"
    >
      <template slot="button-contents">
        <img
          class="ai-logo"
          src="~@/assets/ai_stars_color.svg"
          alt="AI Powered Feature"> Translate Goal
        <span class="caret"/>
      </template>
      <template slot="dropdown-items">
        <li
          v-for="language in languages"
          :key="language"><a role="button" @click="changedLanguage(language)">{{ language | capitalize }}</a></li>
        <li
          v-if="betaVisibility"
          v-for="language in betaLanguages"
          :key="language"><a role="button" @click="changedLanguage(language)">{{ language | capitalize }}</a></li>
      </template>
    </A11y-Dropdown>
    <LimitActionModal
      v-if="isTrial || isLicenseExpired"
      :show.sync="showBlockerModal"
      :action-permissions="permissions" />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import A11yDropdown from '@/components/A11yDropdown'
import LimitActionModal from '@/components/LimitActionModal'
import { actionPermissions, ACTION_TYPES, CONTENT_TYPES } from '@/util/access_visibility'

export default {
    name: 'TranslateButton',
    components: {
      A11yDropdown,
      LimitActionModal
    },
    data() {
    return {
      selectedLanguage: '',
      htmlId: 'translate-button',
      showBlockerModal: false
    }
  },
    computed: {
        ...mapGetters({
            isTrial: 'user/isTrial',
            isLicenseExpired: 'user/isLicenseExpired',
            authInfo: 'user/authInfo',
            languages: 'customanchor/goalTranslationLanguages',
            betaLanguages: 'customanchor/betaGoalTranslationLanguages',
            betaVisibility: 'visibility/betaVisibility'
        }),
        permissions() {
            return actionPermissions(ACTION_TYPES.TRANSLATE, CONTENT_TYPES.GOAL, {}, this.authInfo)
        }
    },
    methods: {
    changedLanguage(language) {
      this.selectedLanguage = language
      this.$emit('translationLanguageChanged', language)
    },
    openedDropdown() {
        if (this.isTrial || this.isLicenseExpired) {
            this.showBlockerModal = true
        }
    }
  }
}
</script>
<style scoped lang="less">
@import '~bootstrap/less/mixins/buttons';
@import '~@/variables.less';
  .ai-logo {
    width: 10px;
    height: var(--size-icon-xs);
  }
  /deep/ .btn-gb-light {
    .button-variant(@gray-dark, white, rgb(140, 140, 140));
  }
  .btn-group {
    float: none;
    margin-top: -4px;
  }
  .caret {
    margin-left: 12px;
  }
  /deep/ .dropdown-menu {
    min-width: 125px;
  }
  .dropdown-menu > li > a {
    font-size: 12px;
  }
</style>